// utils/i18n.js
import enTranslations from './en.js'

/**
 * 从URL获取语言参数
 */
export function getLangFromUrl() {
	const urlParams = new URLSearchParams(window.location.search);
	const lang = urlParams.get('lang');
	return lang === 'en' ? 'en' : 'zh'; // 默认返回中文
}

/**
 * 创建本地化实例
 */
export function setupI18n() {
	const currentLang = getLangFromUrl();

	/**
	 * 翻译函数
	 * @param {string} text - 中文文本
	 * @returns {string} 翻译后的文本
	 */
	const t = (text) => {
		// 如果当前语言是中文，直接返回中文文本
		if (currentLang !== 'en') {
			return text;
		}

		// 如果是英文，查找对应的英文翻译
		return enTranslations[text] || text; // 如果找不到翻译，返回原文本
	}

	return {
		currentLang,
		t
	}
}